export const MINUTES_IN_DAY = 1440;

export const MAX_GRACE_PERIOD_MINUTES = 60;

export const SLOT_MINUTES_VALUES = [15, 30, 60];

export const MAX_PER_SLOT = 100;

export function isMinuteOfDay(value) {
  return Number.isInteger(value) && value >= 0 && value < MINUTES_IN_DAY;
}

export function isGracePeriod(value) {
  return Number.isInteger(value) && value >= 0 && value <= MAX_GRACE_PERIOD_MINUTES;
}

export function isSlotMinutes(value) {
  return SLOT_MINUTES_VALUES.includes(value);
}

export function isMaxPerSlot(value) {
  return Number.isInteger(value) && value >= 1 && value <= MAX_PER_SLOT;
}

export function formatTimeOfDay(minutes) {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}

export function formatGraceLabel(minutes) {
  if (!minutes) return "No grace period";
  if (minutes === MAX_GRACE_PERIOD_MINUTES) return "1 hour";

  return `${minutes} minutes`;
}

/** Returns an errors object; an empty object means the draft is submittable. */
export function validateShift(draft) {
  const errors = {};

  if (!draft.name || !draft.name.trim()) {
    errors.name = "Name is required";
  }

  if (!isMinuteOfDay(draft.startTime)) {
    errors.startTime = "Pick a start time";
  }

  if (!isMinuteOfDay(draft.endTime)) {
    errors.endTime = "Pick an end time";
  }

  if (!errors.startTime && !errors.endTime && draft.startTime === draft.endTime) {
    errors.endTime = "End time must differ from the start time";
  }

  if (!isGracePeriod(draft.gracePeriodMinutes)) {
    errors.gracePeriodMinutes = `Grace period must be between 0 and ${MAX_GRACE_PERIOD_MINUTES} minutes`;
  }

  if (!isMaxPerSlot(draft.maxCollectPerSlot)) {
    errors.maxCollectPerSlot = `Maximum pickups must be between 1 and ${MAX_PER_SLOT}`;
  }

  if (!isMaxPerSlot(draft.maxParkPerSlot)) {
    errors.maxParkPerSlot = `Maximum vehicles to park must be between 1 and ${MAX_PER_SLOT}`;
  }

  if (!isSlotMinutes(draft.slotMinutes)) {
    errors.slotMinutes = "Pick a period length";
  }

  return errors;
}
